import './polyfill'

export { loadConfig } from './load'
